import { render } from "./ImportPage.vue?vue&type=template&id=428cdbc8&scoped=true"
import script from "./ImportPage.vue?vue&type=script&lang=js"
export * from "./ImportPage.vue?vue&type=script&lang=js"

import "./ImportPage.vue?vue&type=style&index=0&id=428cdbc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428cdbc8"]])

export default __exports__